import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";

import {
  PathEnry,
  createPathFromEntries,
} from "../../navigation/createPathFromEntries";
import { getDealerBasePath } from "../../navigation/getDealerBasePath";
import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { SearchFormState } from "../../stores/slices/searchFormSlice";
import { Button } from "../../ui/Button/Button";
import { ArrowLeftIcon } from "../../ui/icons/ArrowLeftIcon";
import { tabPartNubmer, tabTireSize, tabVehicle } from "../SearchForm/Tabs";

type BackToStoreProps = {
  className?: string;
};

export const getBackToResultsPath = ({
  activeTab,
  partNumber,
  productType,
  tireSize,
  vehicleManufacturerName,
  vehicleModelClassId,
  vehicleModelName,
  vehicleSubmodel,
  vehicleYear,
}: SearchFormState): string => {
  const basePath = getDealerBasePath();
  switch (activeTab) {
    case tabVehicle: {
      const entries: PathEnry[] = [
        ["product", productType],
        ["type", "vehicle-search"],
        ["year", vehicleYear],
        ["make", vehicleManufacturerName],
        ["category", String(vehicleModelClassId)],
        ["model", vehicleModelName],
        ["trim", vehicleSubmodel],
      ].filter(([, value]) => Boolean(value)) as PathEnry[];

      if (entries.length === 7) {
        return createPathFromEntries(entries, basePath);
      }
      return basePath;
    }
    case tabTireSize: {
      if (tireSize) {
        return `${basePath}/search/tiresize-search/${encodeURIComponent(
          tireSize
        )}`;
      }
      return basePath;
    }
    case tabPartNubmer: {
      if (partNumber) {
        return `${basePath}/search/partnumber-search/${encodeURIComponent(
          partNumber
        )}`;
      }
      return basePath;
    }

    default:
      return basePath;
  }
};

export const BackToStore: FunctionComponent<BackToStoreProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const [searchForm] = useSearchForm();
  return (
    <Link to={getBackToResultsPath(searchForm)}>
      <Button
        aria-label="backToStore"
        className={clsx("inline-flex text-ink-2 font-thin -ml-4", className)}
        element="a"
      >
        <ArrowLeftIcon />
        {t("cart.backToStore")}
      </Button>
    </Link>
  );
};
